var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-center pb-20"},[_c('img',{staticClass:"w-400px no-select",attrs:{"src":"media/error/under-construction.png","alt":"under-construction"}}),_c('div',{staticClass:"h4 font-weight-normal text-dark-50"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }